<div class="cl-container">

  <!-- ─── Action Bar ─── -->
  <div class="cl-action-bar">

    <!-- Search (left) -->
    <div class="cl-search-wrap">
      <input
        type="text"
        [(ngModel)]="search"
        (ngModelChange)="onSearchChange()"
        placeholder="Search by session ID..."
        class="cl-input cl-input-search"
      />
      <button *ngIf="search" (click)="search = ''; page = 1" class="cl-clear-btn">&#x2715;</button>
    </div>

    <!-- Date Filters -->
    <span class="cl-label">From:</span>
    <input type="date" [(ngModel)]="fromDate" (ngModelChange)="page = 1" class="cl-input cl-input-date" />
    <span class="cl-arrow">&#8594;</span>
    <span class="cl-label">To:</span>
    <input type="date" [(ngModel)]="toDate" (ngModelChange)="page = 1" class="cl-input cl-input-date" />

    <button class="cl-btn cl-btn-secondary" (click)="clearFilters()">Clear</button>

    <!-- Count -->
    <span class="cl-count">
      <ng-container *ngIf="search || fromDate || toDate">{{ filtered.length }} of {{ sessions.length }} sessions</ng-container>
      <ng-container *ngIf="!search && !fromDate && !toDate">{{ sessions.length }} sessions</ng-container>
    </span>
  </div>

  <!-- ─── Table ─── -->
  <div class="cl-table-wrap">

    <!-- Skeleton -->
    <table *ngIf="loading" class="cl-table">
      <thead>
        <tr>
          <th class="cl-th cl-th-num">Sr No</th>
          <th class="cl-th">Session ID</th>
          <th class="cl-th cl-th-usertype">User Type</th>
          <th class="cl-th cl-th-msgs">Messages</th>
          <th class="cl-th cl-th-score">Avg. Similarity Score</th>
          <th class="cl-th cl-th-date">Last Active</th>
          <th class="cl-th cl-th-action">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let sk of skeletonRows" class="cl-skeleton-row">
          <td class="cl-td"><div class="cl-sk cl-sk-xs"></div></td>
          <td class="cl-td"><div class="cl-sk cl-sk-session"></div></td>
          <td class="cl-td"><div class="cl-sk cl-sk-md"></div></td>
          <td class="cl-td"><div class="cl-sk cl-sk-xs"></div></td>
          <td class="cl-td"><div class="cl-sk cl-sk-md"></div></td>
          <td class="cl-td"><div class="cl-sk cl-sk-md cl-sk-right"></div></td>
          <td class="cl-td"><div class="cl-sk cl-sk-md" style="margin:0 auto"></div></td>
        </tr>
      </tbody>
    </table>

    <!-- Data Table -->
    <table *ngIf="!loading" class="cl-table">
      <thead>
        <tr>
          <th class="cl-th cl-th-num">Sr No</th>
          <th class="cl-th">Session ID</th>
          <th class="cl-th cl-th-usertype">User Type</th>
          <th class="cl-th cl-th-msgs">Messages</th>
          <th class="cl-th cl-th-score">Avg. Similarity Score</th>
          <th class="cl-th cl-th-date">Last Active</th>
          <th class="cl-th cl-th-action">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let s of pageData; let idx = index"
          class="cl-tr"
          [ngClass]="getRowClass(idx)">

          <td class="cl-td cl-td-num">{{ getRowIndex(idx) }}</td>

          <td class="cl-td cl-td-session">
            <span class="cl-session-id" [title]="s.sessionId">{{ shortSessionId(s.sessionId) }}</span>
          </td>

          <td class="cl-td cl-td-usertype">
            <span class="cl-usertype-badge"
              [ngClass]="getUserType(s) === 'Registered' ? 'cl-usertype-reg' : 'cl-usertype-unreg'">
              {{ getUserType(s) }}
            </span>
          </td>

          <td class="cl-td cl-td-msgs">
            <span class="cl-msg-badge">{{ s.messageCount }}</span>
          </td>

          <td class="cl-td cl-td-score">
            {{ getAvgScore(s) | number:'1.2-4' }}
          </td>

          <td class="cl-td cl-td-date">{{ formatDate(s.lastDate) }}</td>

          <td class="cl-td cl-td-action">
            <button class="cl-icon-btn cl-icon-btn-view" (click)="openSession(s)" title="View conversation">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                <circle cx="12" cy="12" r="3"/>
              </svg>
            </button>
          </td>
        </tr>

        <tr *ngIf="pageData.length === 0">
          <td colspan="7" class="cl-td cl-td-empty">No sessions found.</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- ─── Pagination ─── -->
  <div class="cl-pagination">
    <div class="cl-page-nav">
      <button class="cl-btn cl-btn-page" [disabled]="page === 1" (click)="page = page - 1">Prev</button>
      <button class="cl-btn cl-btn-page" [disabled]="page === totalPages" (click)="page = page + 1">Next</button>
      <span class="cl-page-info">Page {{ page }} of {{ totalPages }}</span>
    </div>
    <div class="cl-rows-wrap">
      <span class="cl-label">Rows per page</span>
      <select [(ngModel)]="rowsPerPage" (ngModelChange)="page = 1" class="cl-select">
        <option [value]="5">5</option>
        <option [value]="10">10</option>
        <option [value]="25">25</option>
        <option [value]="50">50</option>
      </select>
    </div>
  </div>

</div>

<!-- ─── Session Detail Modal ─── -->
<div *ngIf="showSessionModal" class="cl-overlay">
  <div class="cl-session-modal" (click)="$event.stopPropagation()">

    <!-- Modal Header -->
    <div class="cl-session-header">
      <div class="cl-header-icon">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
        </svg>
      </div>
      <div class="cl-session-title">
        <div class="cl-session-label">Conversation</div>
        <div class="cl-session-id-full">{{ selectedSessionId }}</div>
      </div>
      <div class="cl-session-meta">
        {{ sessionMessages.length }} msg{{ sessionMessages.length !== 1 ? 's' : '' }}
      </div>
      <button class="cl-close-btn" (click)="closeSession()">&#x2715;</button>
    </div>

    <!-- Conversation -->
    <div class="cl-conversation">
      <ng-container *ngFor="let group of groupedMessages">

        <!-- DATE HEADER (WhatsApp style) -->
        <div class="cl-date-separator">
          {{ group[0] }}
        </div>

        <ng-container *ngFor="let msg of group[1]">

        <!-- User bubble (question) -->
        <div *ngIf="getQuestion(msg)" class="cl-bubble-wrap cl-bubble-user">
          <div class="cl-avatar cl-avatar-user">U</div>
          <div class="cl-bubble cl-bubble-q">
            <div class="cl-bubble-text">{{ getQuestion(msg) }}</div>
            <div class="cl-bubble-time">{{ formatTime(msg.createdAt) }}</div>
          </div>
        </div>

        <!-- Bot bubble (answer) -->
        <div *ngIf="getAnswer(msg)" class="cl-bubble-wrap cl-bubble-bot">
          <div class="cl-avatar cl-avatar-bot">AI</div>
          <div class="cl-bubble cl-bubble-a">
            <div class="cl-bubble-text">{{ getAnswer(msg) }}</div>
            <div class="cl-bubble-footer">
              <div class="cl-bubble-time">{{ formatTime(msg.createdAt) }}</div>
              <div class="cl-score-badge">
                Score: {{ (msg.similarityScore ?? 0) | number:'1.2-4' }}
              </div>
            </div>
          </div>
        </div>
        </ng-container>
      </ng-container>

      <div *ngIf="sessionMessages.length === 0" class="cl-no-messages">
        No messages found for this session.
      </div>
    </div>

  </div>
</div>

<!-- ─── Toasts ─── -->
<div class="cl-toasts">
  <div
    *ngFor="let t of toasts"
    class="cl-toast"
    [ngClass]="t.type === 'success' ? 'cl-toast-success' : 'cl-toast-error'">
    <span class="cl-toast-icon" [ngClass]="t.type === 'success' ? 'cl-icon-success' : 'cl-icon-error'">
      {{ t.type === 'success' ? '✓' : '✕' }}
    </span>
    <span class="cl-toast-text">{{ t.message }}</span>
  </div>
</div>
